import { render, staticRenderFns } from "./sk.vue?vue&type=template&id=08a33bd8"
import script from "./sk.vue?vue&type=script&lang=js"
export * from "./sk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports